import { render, staticRenderFns } from "./app_bar_account.vue?vue&type=template&id=2bcb8961&scoped=true&"
import script from "./app_bar_account.vue?vue&type=script&lang=js&"
export * from "./app_bar_account.vue?vue&type=script&lang=js&"
import style0 from "./app_bar_account.vue?vue&type=style&index=0&id=2bcb8961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb8961",
  null
  
)

export default component.exports